import { useQuery } from '@tanstack/react-query'

import { listChannels } from './api'
import { isChannelConnecting } from './channelStatus'

/**
 * Enquanto algum canal esta em transicao (Created/WaitingForPairing), a lista se atualiza sozinha
 * para o status "Conectado" aparecer assim que o pareamento conclui — sem o usuario recarregar.
 */
const POLL_INTERVAL_MS = 4_000

export function channelsQueryKey(tenantId: string) {
  return ['channels', 'list', tenantId] as const
}

/** Canais do tenant (id, nome, tipo, status de conexao), para a tela de Canais. */
export function useChannels(tenantId: string | undefined) {
  return useQuery({
    queryKey: channelsQueryKey(tenantId ?? ''),
    queryFn: () => listChannels(tenantId ?? ''),
    enabled: tenantId !== undefined,
    refetchInterval: (query) => {
      const data = query.state.data
      if (data === undefined || data.length === 0) {
        return false
      }
      return data.some((channel) => isChannelConnecting(channel.status)) ? POLL_INTERVAL_MS : false
    },
  })
}
